import { Link } from '@remix-run/react';
import { Linkedin, Github } from 'lucide-react';

import { type Employee } from '~/domain/cms/Types.ts';

interface Props {
  employee: Employee;
}

export function EmployeeDetail({ employee }: Props) {
  return (
    <div className="py-3">
      <Link to={`/team/${employee.slug}`} className="flex flex-col items-center justify-center">
        <img
          className="h-[150px] w-[150px] rounded-full md:h-[250px] md:w-[250px]"
          src={employee.image}
          alt={employee.name}
        />
        <div className="mt-2 text-center text-2xl font-bold md:text-3xl">{employee.name}</div>
        <div className="mt-2 text-center text-lg font-normal md:text-xl">{employee.title}</div>
      </Link>
      <div className="mt-2 flex flex-row justify-center">
        {employee.linkedin && (
          <a href={employee.linkedin} target="_blank" rel="noreferrer" className="mx-3">
            <Linkedin />
          </a>
        )}
        {employee.github && (
          <a href={employee.github} target="_blank" rel="noreferrer" className="mx-3">
            <Github />
          </a>
        )}
      </div>
    </div>
  );
}
